(()=>{const q=(s,r=document)=>r.querySelector(s),qa=(s,r=document)=>[...r.querySelectorAll(s)];
function init(root){
  const list=q('[data-mcp]',root)||root, ul=q('#MCP-'+list.dataset.section,root); if(!ul) return;
  const items=qa('[data-mcp-item]',ul), per=parseInt(list.dataset.perPage||'0',10)||items.length;
  const pag=q('[data-mcp-pagination]',root); if(!pag) return;
  const pagesWrap=q('.mcp__pages',pag), prev=q('.mcp__btn--prev',pag), next=q('.mcp__btn--next',pag);
  const total=Math.max(1,Math.ceil(items.length/per)); if(total<=1){pag.hidden=true; return;}
  let p=1; pag.hidden=false;

  const renderBtns=()=>{
    pagesWrap.innerHTML='';
    for(let i=1;i<=total;i++){
      const b=document.createElement('button');
      b.type='button'; b.className='mcp__page'+(i===p?' is-active':''); b.textContent=i;
      b.addEventListener('click',()=>go(i));
      pagesWrap.appendChild(b);
    }
  };

  const paint=()=>{
    const a=(p-1)*per, b=a+per;
    items.forEach((it,i)=>{it.style.display=(i>=a&&i<b)?'':'';});
    prev.disabled=(p<=1); next.disabled=(p>=total);
    qa('.mcp__page',pagesWrap).forEach((btn,i)=>btn.classList.toggle('is-active',i+1===p));
    ul.scrollIntoView({block:'start',behavior:'smooth'});
  };

  const go=(n)=>{p=Math.min(Math.max(1,n),total); paint();};
  prev.addEventListener('click',()=>go(p-1));
  next.addEventListener('click',()=>go(p+1));
  renderBtns(); paint();
} 

document.addEventListener('DOMContentLoaded',()=>qa('[data-mcp]').forEach(sec=>init(sec.closest('.multicolumn--paged')||document)));
})();